import { Workflow } from '@/stores/workflowStore';

export function exportWorkflow(workflow: Workflow): string {
  return JSON.stringify(workflow, null, 2);
}

export function exportWorkflowAsJSON(workflow: Workflow): void {
  const json = exportWorkflow(workflow);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${workflow.name}.json`;
  link.click();
  URL.revokeObjectURL(url);
}

export function importWorkflow(jsonString: string): Workflow {
  try {
    const workflow = JSON.parse(jsonString) as Workflow;
    
    // Validate workflow structure
    if (!workflow.id || !workflow.name || !Array.isArray(workflow.nodes) || !Array.isArray(workflow.edges)) {
      throw new Error('Invalid workflow format');
    }

    return workflow;
  } catch (error) {
    throw new Error(`Failed to import workflow: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

export function exportAllWorkflows(workflows: Workflow[]): void {
  const json = JSON.stringify(workflows, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `workflows-backup-${Date.now()}.json`;
  link.click();
  URL.revokeObjectURL(url);
}
